export default __webpack_public_path__ + "static/media/01_standard.dd0da0e0.png";